import styled from '@emotion/styled';
import type { Theme } from '@emotion/react';

export const ConversationContent = styled.div<{ show?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  overflow: hidden;

  @media ${({ theme }: { theme: Theme }) => theme.medias.mobile} {
    position: fixed;
    top: 0;
    left: 0;

    height: 100vh;
    z-index: 40;
  }

  & > .header {
    height: 60px;
    width: 100%;
    padding: 10px;
  }

  & > .content {
    height: calc(488px - 147px);
    overflow-y: auto;
    padding: 10px;
    width: 100%;
  }
  ${(props) => (props.show ? '' : 'display: none;')}
`;

const welcomeLayout = `
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;

	& > img {
		display: block;
		max-width: 95%;
		width: 320px;
		object-fit: contain;
		height: auto;
	}

	& > h4 {
		font-weight: 500;
		font-size: 24px;
		line-height: 36px;
		text-align: center;
		color: #2e2d37;
		margin-bottom: 12px;
	}

	& > p {
		font-weight: normal;
		font-size: 12px;
		line-height: 18px;
		text-align: center;
		color: #2e2d37;
		width: 371px;
		max-width: 95%;
	}
`;

export const Conversation = styled.section<{ welcome?: boolean }>`
	background-position: fixed;
	background-size: 175%;

	border-left: 1px solid #ecedf2;

	height: 100dvh;

	display: flex;
	flex-direction: column;
	overflow: hidden;

	@media ${({ theme }) => theme.medias.desktop} {
		height: 100%;
		overflow: hidden;
	}

	${({ welcome }) => welcome && welcomeLayout}
`;

export const Wrapper = styled.div`
	position: relative;

	width: 100%;
	flex: 1;
	min-height: 0;
`;

export const Scroller = styled.div`
	position: absolute;
	top: 0;
	left: 0;

	padding-top: 20px;

	display: flex;
	flex-direction: column;
	box-sizing: border-box;

	width: 100%;
	height: 100%;

	overflow-y: auto;
	overflow-x: hidden;

	-webkit-overflow-scrolling: touch;

	${({ theme }) => (theme?.mixins?.scrollBar ? theme.mixins.scrollBar : '')}
	border-left: 1px solid transparent;
`;

export const MessagesContainer = styled.div`
	display: block;
	position: relative;

	@media ${({ theme }) => theme.medias.desktop} {
		@supports (display: flex) {
			display: flex;
			flex: 1;
			flex-direction: column;
		}

		border-left: 0;
	}
`;

export const BlockedArea = styled.div`
	width: 100%;
	height: 100%;
	background: #f5f5f5;
`;
